import { atom } from 'recoil';
import { ServiceOrder, SummaryServiceOrder } from 'types/serviceOrder.types';

const PREFIX_KEY = 'src/pages/ServiceOrdersPage/';

export const serviceOrdersAtom = atom<ServiceOrder[] | SummaryServiceOrder[] | undefined>({
  key: `${PREFIX_KEY}serviceOrders.atom`,
  default: [],
});
